import { App } from "@vue/runtime-core";
import Popper from "vue3-popper";

export default (app: App): void => {
  app.component("popper", Popper);
};
